import { AnimateOnScroll, AnimateOnScrollChild } from "./_transitions/animate_on_scroll";

const WorkflowCard = ({ workflowdata, language = '' }: { workflowdata: any, language?: string }) => {
    if (!workflowdata) return null;
    
    let Header = workflowdata?.Header || { ColorOne: 'Common Agentic', ColorTwo: 'Workflow' };
    let items = workflowdata?.Card || [];
    const locateSrc = (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') ? '/backend/public' : '';

    return (
        <AnimateOnScroll as="section" transition=" " className='workflowCard'>
            <AnimateOnScrollChild as={`h2`} className="h2-main" transition={`fade`}>
                {Header.ColorOne}
                {language=="en"?" ":""}
                <AnimateOnScrollChild as={`span`} transition={`fade`} delay={200}>
                    {Header.ColorTwo}
                </AnimateOnScrollChild>
            </AnimateOnScrollChild>
            <div className='item-container container'>
                {items.map((item: any, index: number) => (
                    <AnimateOnScrollChild transition="slide-up" delay={ (index * 100) + 400 } className='item' key={index}>
                        <div className='icon'>
                            <img 
                                src={`${locateSrc}${item.Icon?.url}` || "/images/icons/octodap-01-ai-driven.svg"} 
                                alt={item.Title || "Common Agentic Workflow"} 
                            />
                        </div>
                        <h3>{item.Title || 'Meeting Audio to Minutes'}</h3>
                    </AnimateOnScrollChild>
                ))}
            </div>
        </AnimateOnScroll>
    );
}

export default WorkflowCard;
